import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';
import { siteInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/70">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 text-lg font-heading font-bold text-foreground-950 whitespace-nowrap cursor-pointer">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                  萝
                </span>
                狗头萝莉视频
              </Link>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                狗头萝莉视频内容聚合平台，为粉丝提供最新最全的直播录屏、搞笑片段、日常Vlog等精选内容。关注狗头萝莉，精彩不容错过！
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href={siteInfo.socialLinks.bilibili} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer text-foreground-600">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer text-foreground-600">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href={siteInfo.socialLinks.douyin} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer text-foreground-600">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">视频分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/live-recordings" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    直播录屏
                  </Link>
                </li>
                <li>
                  <Link to="/category/highlights" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    精彩集锦
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-mail-line text-foreground-500"></i>
                  </span>
                  <span className="text-sm text-foreground-600">{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-foreground-500"></i>
                  </span>
                  <span className="text-sm text-foreground-600">{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 狗头萝莉视频. 版权所有.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}